const DAY = 86400000;
const prefix = () => `delibran:shop-cart:v1:${window.location.host}:`;
const key = (owner) => prefix() + (owner || "guest");
const intentId = () =>
  typeof window !== "undefined" && window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
        const value = Math.floor(Math.random() * 16);
        return (char === "x" ? value : (value & 3) | 8).toString(16);
      });
export const freshIntent = () => ({
  clientCartId: intentId(),
  modifiedAt: new Date().toISOString(),
});
export const readCart = (owner) => {
  try {
    const record = JSON.parse(localStorage.getItem(key(owner)));
    const time = Date.parse(record?.modifiedAt);
    if (
      !record ||
      !Number.isFinite(time) ||
      time > Date.now() + 60000 ||
      Date.now() - time > (owner ? 7 : 3) * DAY ||
      !Array.isArray(record.ShoppingCartProducts)
    ) {
      localStorage.removeItem(key(owner));
      return null;
    }
    return record;
  } catch {
    return null;
  }
};
export const saveCart = (cart, owner) => {
  try {
    if (!cart?.modifiedAt || !cart.clientCartId)
      localStorage.removeItem(key(owner));
    else localStorage.setItem(key(owner), JSON.stringify(cart));
  } catch {
    /* Private storage may be unavailable; the in-memory selection remains usable. */
  }
};
export const forgetGuest = () => {
  try {
    localStorage.removeItem(key());
  } catch {
    /* Storage may be unavailable; removing the persisted guest cart is best effort. */
  }
};
export const cartIntent = (cart, owner) =>
  cart?.clientCartId && cart?.modifiedAt
    ? {
        clientCartId: cart.clientCartId,
        modifiedAt: cart.modifiedAt,
        days: owner ? 7 : 3,
        lines: (cart.ShoppingCartProducts || []).map(
          ({ productId, quantity, variantId, itemIds, note }) => ({
            productId,
            quantity,
            variantId,
            itemIds: itemIds || [],
            note,
          }),
        ),
      }
    : null;
export const serverCart = (cart) => ({
  ...cart,
  clientCartId: cart.shoppingCartId,
  modifiedAt: cart.intentModifiedAt || cart.updatedAt,
});
